import axios from "axios";
var CryptoJS = require("crypto-js");

////....test....../////
//const newBaseUrl = process.env.NODE_ENV === 'development' ? "/" : "https://qt-medialibrary-be-484629544897.me-central1.run.app/"

////......prod.....////
const newBaseUrl = "https://qt-medialibrary-prod-be-47525798142.me-central1.run.app/"

/////.......test.....////
//const regenerateBaseUrl = "https://qt-medialibrary-be-trigger-484629544897.me-central1.run.app/"

////....prod...////
const regenerateBaseUrl = "https://qt-medialibrary-prod-be-trigger-47525798142.me-central1.run.app/"

// Shared axios instance — all BE calls go through here so the interceptors fire once.
const api = axios.create();

// Request interceptor: attach session token when present
api.interceptors.request.use((config) => {
    const token = window.localStorage.getItem("sessionToken");
    if (token) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
});

// Response interceptor: 401 → logout
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            // Lazy import to avoid circular dep; logout clears redux + localStorage + redirects
            import("../utils/logout").then(({ performLogout }) => {
                import("../redux/store").then(({ default: store }) => {
                    performLogout(store.dispatch);
                });
            }).catch(() => {});
        }
        return Promise.reject(error);
    }
);

function logClientError(event, message, extra = {}) {
    try {
        axios.post(newBaseUrl + "api/common/clientLog", {
            severity: "ERROR",
            event,
            message: String(message),
            userId: extra.userId,
            ...extra,
        }).catch(() => {});
    } catch (_) {}
}

export async function apiCalling(url, postData) {
    let baseUrl = newBaseUrl + url
    const data = await api.post(baseUrl, postData);
    const res = data;
    return res;
}

export async function apiCallingPost(url, postData) {
    let baseUrl = newBaseUrl + url;
    const ENC_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

    try {
        const response = await api.post(baseUrl, postData);
        
        const bytes = CryptoJS.AES.decrypt(response.data.token, ENC_KEY);
        let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        decryptedData = JSON.parse(decryptedData);

        return {
            data: decryptedData,
        };
    } catch (error) {
        logClientError('API_CALL_ERROR', error?.message || String(error), { endpoint: url });
        console.error("Error in API call:", error);
        throw error;
    }
}
export async function apiCallingRegenerateTag(url, postData) {
    let baseUrl = regenerateBaseUrl + url;
    const ENC_KEY = process.env.REACT_APP_ENCRYPTION_KEY; // 32 DIGITS

    try {
        const response = await api.post(baseUrl, postData);

        const bytes = CryptoJS.AES.decrypt(response.data.token, ENC_KEY);
        let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        decryptedData = JSON.parse(decryptedData);

        return {
            data: decryptedData,
        };
    } catch (error) {
        logClientError('API_REGENERATE_TAG_ERROR', error?.message || String(error), { endpoint: url });
        console.error("Error in API call:", error);
        throw error;
    }
}
export async function apiCallingTriggerPost(url, postData) {
    let baseUrl = regenerateBaseUrl + url;
    try {
        const response = await api.post(baseUrl, postData);
        return response;
    } catch (error) {
        logClientError('API_TRIGGER_ERROR', error?.message || String(error), { endpoint: url });
        console.error("Error in trigger API call:", error);
        throw error;
    }
}
export async function apiCallingGetDecrypted(url) {
    const baseUrl = newBaseUrl + url;
    return {
        responseData: baseUrl
    };
}

// Authorize a download (server runs the access rulebook) and return a ready-to-use
// download URL carrying a short-lived signed pass. Drop-in replacement for the old
// apiCallingGetDecrypted(download_zip?videoId=...) call. Throws if not authorized.
// `files` = [{ fileId, type }]; `shareUrl` = the share link for share-page downloads, else null.
export async function prepareDownload(files, shareUrl = null) {
    const res = await apiCallingPost('api/download/prepare', { files, shareUrl });
    if (res.data.success === '1' && res.data.downloadToken) {
        return { responseData: newBaseUrl + 'api/download/download_zip?token=' + encodeURIComponent(res.data.downloadToken) };
    }
    throw new Error(res.data.errorMessage || 'Not authorized to download.');
}
// Read by utils/logout.js so the logout audit uses the same backend (no second copy of the host).
export { newBaseUrl };
